<div style="transition: all 2s linear">
    <div class="preference-option-sub-heading-text ratings-container d-sm-flex d-xs-block">
        <div class="rating-option col-sm-4 col-xs-12 col-12" *ngFor="let preference of availablePreferences">
            <mat-checkbox (change)="setCustomPortfolioPreference(preference.value, $event.checked)"
                [checked]="isCategorySelected(preference.value)">
                <div class="text-left">
                    <p class="option-label"><strong>{{preference.title}}</strong> ({{preference.label}})</p>
                    <p class="option-sub-label">{{preference.subLabel}}</p>
                </div>
            </mat-checkbox>
        </div>
    </div>
    <p class="text-error" *ngIf="areCategoriesEmpty(preferredCategories)">Please select minimum two interest rate & risk range</p>
    <p class="text-error" *ngIf="forbiddenRatingsAlertType === 'error' &&
   !areCategoriesEmpty(preferredCategories) &&
   containsOnlyForbiddenRatings(preferredCategories)">
        Selection of only B4-B6 categories is not allowed.
    </p>
    <p class="text-warn" *ngIf="forbiddenRatingsAlertType === 'warn' &&
   !areCategoriesEmpty(preferredCategories) &&
   containsOnlyForbiddenRatings(preferredCategories)">
        We do not want you take excessive risk by only selecting B4-B6. We would strongly recommend you to diversify
        your investments across categories by selecting more rating preferences.
    </p>
</div>